import React from 'react';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import Redirect from 'react-router-dom/Redirect';

import index from '../index';
import search from '../search';
import category from '../category';
import notfound from '../notfound';
import recharge from '../recharge';
import minautumnrecharge from '../midautumnrecharge';
import newyearrecharge from '../newyearrecharge';
import qingmingrecharge from '../qingmingrecharge';
import wuyirecharge from '../wuyirecharge';
import dubleonecharge from '../dubleonecharge';
import payactivity from '../payactivity';
import payyear from '../payyear';
import paybigbag from '../paybigbag';
import rank from '../rank';
import mine from '../mine';
import recentlyread from '../recentlyread';
import feedback from '../feedback';
import packet from '../packet';
import balance from '../balance';
import signin from '../signin';
import catalogue from '../catalogue';
import follow from '../follow';
import readpage from '../readpage';
import offlineBook from '../offlineBook';
import wuliulist from '../wuliulist';
import wuliuinfo from '../wuliuinfo';
import cj1 from '../cj1';
import libao from '../libao';
import tsPage from '../tsPage';

import qxsGetMoney from '../quxiaoshuo/getMoney';
import qxsGetMoneyNew from '../quxiaoshuo/getMoneyNew';
import qxsZJ from '../quxiaoshuo/zj';
import testInterface from '../testInterface';
import duanwurecharge from '../duanwurecharge';
import rotaryDraw from '../rotaryDraw';
import rotaryList from '../rotaryList';
import shubao from '../shubao';
import activeFirstDayForYear from '../activeFirstDayForYear';
import TouchBottom from "../shareComponent/touchBottom";
import shareErCode from "../shareErCode";

function onEnter(Component, props, withTouchBottom) {
    return false
    try{
        let parval = document.getElementById("parval");
        if(!!parval && parval.value == 1){
            let val = parval.getAttribute("data-val");
            if(!!window.history && val.length > 0){window.history.replaceState({},"","?"+val);}
            parval.remove();
        }
    }catch(e){}
    // 例子：如果没有登录，直接跳转至login页
    // if (sessionStorage.getItem('userInfo')) {
    //   return <Component {...props} />;
    // } else {
    //   return <Redirect to='/login' />;
    // }
    try{
        if (!!window && window._czc) {
            let location = document.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = "/";
            window._czc.push(["_trackPageview", contentUrl, refererUrl]);
        }
    }catch(e){}
    let curHref = "";
    try{
        curHref = document.location.href;
    }catch(e){}
    let component = withTouchBottom ? <TouchBottom><Component {...props} key={curHref} /></TouchBottom> : <Component {...props} key={curHref} />;
    return component;
}

const App = () => (
    <Switch>
        <Route exact path={`/`} render={() => <Redirect to={`/index`}></Redirect>}></Route>
        <Route path={`/index`} render={props => onEnter(index, props)}/>{/* 首页 */}
        <Route path={`/search`} render={props => onEnter(search, props)}/>{/* 搜索 */}
        <Route path={`/category`} render={props => onEnter(category, props)}/>{/* 分类 */}
        <Route path={`/recharge/:bookId?`} render={props => onEnter(recharge, props)}/>{/* 充值 */}
        <Route path={`/shareErCode`} render={props => onEnter(shareErCode, props)}/>{/* 分享二维码 */}
        <Route path={`/minautumnrecharge/:bookId?`} render={props => onEnter(minautumnrecharge, props)}/>{/* 中秋活动充值 */}
        <Route path={`/newyearrecharge/:bookId?`} render={props => onEnter(newyearrecharge, props)}/>{/* 春节活动充值 */}
        <Route path={`/qingmingrecharge/:bookId?`} render={props => onEnter(qingmingrecharge, props)}/>{/* 清明活动充值 */}
        <Route path={`/duanwurecharge/:bookId?`} render={props => onEnter(duanwurecharge, props)}/>{/* 端午活动充值 */}
        <Route path={`/wuyirecharge/:bookId?`} render={props => onEnter(wuyirecharge, props)}/>{/* 五一活动充值 */}
        <Route path={`/dubleonecharge/:bookId?`} render={props => onEnter(dubleonecharge, props)}/>{/* 双11活动充值 */}
        <Route path={`/payactivity`} render={props => onEnter(payactivity, props)}/>{/* 充值活动 */}
        <Route path={`/payyear`} render={props => onEnter(payyear, props)}/>{/* 新春充值活动 */}
        <Route path={`/paybigbag`} render={props => onEnter(paybigbag, props)}/>{/* 充值活动2 */}
        <Route path={`/rank`} render={props => onEnter(rank, props)}/>{/* 排行榜 */}
        <Route path={`/mine`} render={props => onEnter(mine, props)}/>{/* 个人中心 */}
        <Route path={`/recentlyread`} render={props => onEnter(recentlyread, props, true)}/>{/* 最近阅读 */}
        <Route path={`/feedback`} render={props => onEnter(feedback, props)}/>{/* 反馈 */}
        <Route path={`/packet`} render={props => onEnter(packet, props)}/>{/* 红包 */}
        <Route path={`/balance`} render={props => onEnter(balance, props)}/>{/* 消费记录 */}
        <Route path={`/signin`} render={props => onEnter(signin, props)}/>{/* 签到 */}
        <Route path={`/catalogue/:bookId`} render={props => onEnter(catalogue, props)}/>{/* 目录 */}
        <Route path={`/follow`} render={props => onEnter(follow, props)}/>{/* 关注中转页面 */}
        <Route path={`/offlineBook`} render={props => onEnter(offlineBook, props)}/>{/* 下线书 */}
        <Route path={`/wuliulist`} render={props => onEnter(wuliulist, props)}/>{/* 物流列表 */}
        <Route path={`/tsPage/:bookId/:contentId`} render={props => onEnter(tsPage, props)}/>{/* 投诉页面 */}
        <Route path={`/wuliuinfo/:giftid?`} render={props => onEnter(wuliuinfo, props)}/>{/* 物流详情 */}
        <Route path={`/cj1/:draw_record_id?`} render={props => onEnter(cj1, props)}/>{/* 物流详情 */}
        <Route path={`/libao/:fee?`} render={props => onEnter(libao, props)}/>{/* 礼包 */}
        <Route path={`/readpage/:bookId/:contentId/:payed?`} render={props => onEnter(readpage, props)}/>{/* 阅读页 */}
        <Route path={`/rotaryDraw`} render={props => onEnter(rotaryDraw, props)}/>{/* 幸运抽大奖 */}
        <Route path={`/rotaryList`} render={props => onEnter(rotaryList, props)}/>{/* 幸运抽大奖获奖列表 */}
        <Route path={`/shubao`} render={props => onEnter(shubao, props)}/>{/* 书包 */}
        
        {/* 趣小说 */}
        {/*<Route path={`/quxiaoshuo/getMoney`} render={props => onEnter(qxsGetMoney, props)}/>/!* 领钱 *!/*/}
        <Route path={`/quxiaoshuo/getMoneyNew`} render={props => onEnter(qxsGetMoneyNew, props)}/>{/* 领钱 */}
        <Route path={`/quxiaoshuo/zj`} render={props => onEnter(qxsZJ, props)}/>{/* 中间跳转页面 */}
        <Route path={`/activeFirstDayForYear`} render={props => onEnter(activeFirstDayForYear, props)}/>{/* 元旦活动页面 */}
        {/* 测试 */}
        <Route path={`/testInterface`} render={props => onEnter(testInterface, props)}/>{/* 接口测试 */}

        {/*<Route component={notfound}/>/!* 404页面 *!/*/}
    </Switch>
);

export default App;